import { formatLocaleDate } from "@/lib/dates";
import { useLocale } from "@/i18n";
import { Notice } from "@/components/Notice";
import { CalendarIcon } from "@/components/ui/Icons";

export interface SoldOutPeriodNoticeProps {
  arrival: string;
  departure: string;
  nights: number;
  message: string;
}

export function SoldOutPeriodNotice({
  arrival,
  departure,
  nights,
  message,
}: SoldOutPeriodNoticeProps) {
  const { messages: m, locale } = useLocale();
  const nightLabel = nights === 1 ? m.common.night : m.common.nights;
  const body = m.availability.periodSoldOutBody(
    formatLocaleDate(arrival, locale),
    formatLocaleDate(departure, locale),
    nights,
    nightLabel,
  );
  const trimmedMessage = message.trim();
  const showMessage = trimmedMessage && trimmedMessage !== body;

  return (
    <Notice variant="warning" title={m.availability.periodSoldOutTitle} icon={<CalendarIcon />}>
      <p>{body}</p>
      {showMessage ? <p className="text-amber-900/80">{trimmedMessage}</p> : null}
      <p className="text-amber-900/80">{m.availability.periodSoldOutHint}</p>
    </Notice>
  );
}
